import type { FC, ReactNode } from 'react'

import { createContext } from 'react'

export const ListingIdContext = createContext('')

type ListingIdProviderProps = {
  children: ReactNode
  listingId: string
} & IElement

export const ListingIdProvider: FC<ListingIdProviderProps> = ({ children, listingId }) => (
  <ListingIdContext.Provider value={listingId}>{children}</ListingIdContext.Provider>
)
